import styled from "styled-components";
import {IndicatorBadgeDefaultBox} from "./indicator-badge.default.box";

export const IndicatorBadgeMrGreenBox = styled(IndicatorBadgeDefaultBox)`
    top: 1rem;
    right: 1.8rem;
    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        right: 6.4rem;
    }
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        right: 5.4rem;
    }
`;
